import "babel-polyfill";
import { render } from 'react-dom';
import { applyMiddleware, createStore, compose } from 'redux';
import { createBrowserHistory, createHashHistory } from 'history'
import configureReducer from './configureReducer';
import configureMiddleware from './configureMiddleware';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import App from './App';
import { actions as config } from './modules/config';
import { actions as user } from './modules/user';
import bootstrap from './common/bootstrap';


const history = createHashHistory({
    hashType: 'slash',
    getUserConfirmation: (message, callback) => callback(window.confirm(message))
});

const middleware = configureMiddleware(history);
const reducer = configureReducer();
const initialState = {};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    connectRouter(history)(reducer),
    initialState,
    composeEnhancers(applyMiddleware(...middleware))
);

store
    .dispatch(config.fetch())
    .then(config => bootstrap(config, profile => store.dispatch(user.update(profile))))
    .then(() => {
        render(
            App({ history, store }),
            document.getElementById('root')
        );
    });
